import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { CategoryPage } from './pages/Category';
import { ProductPage } from './pages/Product';
import { WholesaleApply } from './pages/WholesaleApply';
import { FindSupplier } from './pages/FindSupplier';
import { KitBuilder } from './pages/KitBuilder';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="category/:slug" element={<CategoryPage data-id="element-7" />} data-id="element-6" />
          <Route path="product/:sku" element={<ProductPage data-id="element-9" />} data-id="element-8" />
          <Route path="wholesale-apply" element={<WholesaleApply data-id="element-11" />} data-id="element-10" />
          <Route path="find-a-supplier" element={<FindSupplier data-id="element-13" />} data-id="element-12" />
        </Route>
        {/* Kit Builder outside of main layout for full-screen feel */}
        <Route path="/kit-builder" element={<KitBuilder data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}